module.exports = __webpack_public_path__ + "files/905f29fa0df9e5d1105169f2a481ab78.png";